import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';

const NewsletterContext = React.createContext(null);

export const useNewsletter = () => useContext(NewsletterContext);

const propTypes = {
    newsletter: PropTypes.bool,
    children: PropTypes.node.isRequired,
};

const defaultProps = {
    newsletter: false,
};

export const NewsletterProvider = ({ newsletter: initialNewsletter, children }) => {
    const [newsletter, setNewsletter] = useState(initialNewsletter);
    return (
        <NewsletterContext.Provider value={{ newsletter, setNewsletter }}>
            {children}
        </NewsletterContext.Provider>
    );
};

NewsletterProvider.propTypes = propTypes;
NewsletterProvider.defaultProps = defaultProps;

export default NewsletterContext;
